import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgCustomXlsFile = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "Represents an Excel Spreadsheet (.xls) file",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="32"
    height="41"
    viewBox="0 0 32 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M31.4099 9.26001V37.61C31.4099 38.71 30.5099 39.61 29.4099 39.61H6.62988C5.52988 39.61 4.62988 38.71 4.62988 37.61V2.51001C4.62988 1.41001 5.52988 0.51001 6.62988 0.51001H22.7999L31.4099 9.26001Z"
      fill="white"
    />
    <path
      d="M29.4099 40.1H6.62988C5.24988 40.1 4.12988 38.98 4.12988 37.6V2.5C4.12988 1.12 5.24988 0 6.62988 0H22.7999C22.9299 0 23.0599 0.0500015 23.1599 0.150002L31.7699 8.9C31.8599 8.99 31.9099 9.12 31.9099 9.25V37.6C31.9099 38.98 30.7899 40.1 29.4099 40.1ZM6.62988 1C5.79988 1 5.12988 1.67 5.12988 2.5V37.6C5.12988 38.43 5.79988 39.1 6.62988 39.1H29.4099C30.2399 39.1 30.9099 38.43 30.9099 37.6V9.46L22.5899 1H6.62988Z"
      fill="#C4CBD0"
    />
    <path
      d="M30.8698 9.25998H24.7998C23.6998 9.25998 22.7998 8.35998 22.7998 7.25998V1.16998"
      fill="white"
    />
    <path
      d="M30.8698 9.75998H24.7998C23.4198 9.75998 22.2998 8.63998 22.2998 7.25998V1.16998C22.2998 0.889983 22.5198 0.669983 22.7998 0.669983C23.0798 0.669983 23.2998 0.889983 23.2998 1.16998V7.25998C23.2998 8.08998 23.9698 8.75998 24.7998 8.75998H30.8698C31.1498 8.75998 31.3698 8.97998 31.3698 9.25998C31.3698 9.53998 31.1498 9.75998 30.8698 9.75998Z"
      fill="#C4CBD0"
    />
    <path
      d="M26.03 31.66H1.2C0.540005 31.66 0 31.12 0 30.46V16.52C0 15.86 0.540005 15.32 1.2 15.32H26.03C26.69 15.32 27.23 15.86 27.23 16.52V30.46C27.23 31.12 26.7 31.66 26.03 31.66Z"
      fill="#2BC77C"
    />
    <path
      d="M6.32955 19.7272L7.65767 22.0248H7.71449L9.05682 19.7272H11.0241L8.82955 23.3636L11.0952 26.9999H9.07812L7.71449 24.6775H7.65767L6.29403 26.9999H4.29119L6.54616 23.3636L4.34801 19.7272H6.32955ZM11.9332 26.9999V19.7272H13.6911V25.5724H16.7166V26.9999H11.9332ZM21.5577 21.9076C21.534 21.6472 21.4287 21.4448 21.2417 21.3004C21.057 21.1536 20.793 21.0802 20.4498 21.0802C20.2225 21.0802 20.0331 21.1098 19.8816 21.169C19.7301 21.2282 19.6164 21.3098 19.5407 21.414C19.4649 21.5158 19.4258 21.633 19.4235 21.7656C19.4187 21.8745 19.44 21.9703 19.4874 22.0532C19.5371 22.1361 19.6081 22.2095 19.7005 22.2734C19.7952 22.3349 19.9088 22.3894 20.0414 22.4367C20.1739 22.4841 20.3231 22.5255 20.4888 22.561L21.1138 22.7031C21.4737 22.7812 21.7909 22.8854 22.0655 23.0156C22.3425 23.1458 22.5745 23.3008 22.7615 23.4808C22.9509 23.6607 23.0942 23.8678 23.1912 24.1022C23.2883 24.3366 23.338 24.5994 23.3404 24.8906C23.338 25.3498 23.222 25.744 22.9924 26.0731C22.7627 26.4022 22.4325 26.6543 22.0016 26.8295C21.5731 27.0047 21.0558 27.0923 20.4498 27.0923C19.8413 27.0923 19.311 27.0011 18.8588 26.8188C18.4067 26.6365 18.0551 26.3596 17.8042 25.9879C17.5532 25.6162 17.4242 25.1462 17.4171 24.5781H19.1003C19.1145 24.8124 19.1773 25.0078 19.2885 25.164C19.3998 25.3203 19.5525 25.4386 19.7466 25.5191C19.9431 25.5996 20.1704 25.6399 20.4284 25.6399C20.6652 25.6399 20.8664 25.6079 21.0321 25.544C21.2002 25.4801 21.3292 25.3913 21.4192 25.2776C21.5092 25.164 21.5553 25.0338 21.5577 24.887C21.5553 24.7497 21.5127 24.6325 21.4299 24.5355C21.347 24.436 21.2192 24.3508 21.0463 24.2798C20.8759 24.2064 20.6581 24.1389 20.3929 24.0774L19.633 23.8998C19.0033 23.7554 18.5073 23.5222 18.1451 23.2002C17.7828 22.8759 17.6029 22.4379 17.6053 21.8863C17.6029 21.4365 17.7237 21.0423 17.9675 20.7038C18.2114 20.3652 18.5487 20.1013 18.9796 19.9119C19.4105 19.7225 19.9017 19.6278 20.4533 19.6278C21.0167 19.6278 21.5056 19.7237 21.9199 19.9154C22.3366 20.1048 22.6597 20.3712 22.8894 20.7144C23.119 21.0577 23.2362 21.4554 23.2409 21.9076H21.5577Z"
      fill="white"
    />
  </svg>
);

const CustomXlsFile = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgCustomXlsFile />
  </BaseIcon>
);

export default CustomXlsFile;
